export default "__VITE_PUBLIC_ASSET__656cea35__"